export enum TooltipPosition {
  //AUTO = 'auto',
  //ABOVE = 'above',
  BELOW = 'below'
}
